import { Transactions } from '@/components/transactions-page';
import { Helmet as Head } from 'react-helmet';
import useRefresh from '../../hooks/use-refresh';

const TransactionsPage = () => {
  useRefresh();
  return (
    <>
      <Head>
        <title>Transactions</title>
      </Head>
      <Transactions />
    </>
  );
};

export default TransactionsPage;
